import TXT from '@/messages'
import { ModalState } from '@/types/ModalProvider.types'

export const defaultState: ModalState = {
  open: {
    confirmation: false,
    expiration: false,
    error: false,
    terms: false,
    prompt: false,
    eventDetails: false,
  },
  text: { confirmation: TXT.confirmationModals.default },
  errorType: null,
  errorMessage: '',
  error: null,
}
